// ─── Stripe Service ───────────────────────────────────────
const API_BASE = import.meta.env.VITE_APP_URL || ''

export const PLANS = {
  free: {
    name: 'Free',
    price: 0,
    priceId: null,
    features: [
      'Budget tracking & categorization',
      'Up to 3 linked accounts',
      'Credit score monitoring',
      'Basic spending insights',
      '30-day transaction history',
      '5 AI Coach queries/month',
    ],
    limits: { accounts: 3, aiQueries: 5, historyDays: 30 },
  },
  pro: {
    name: 'Pro',
    price: 7.99,
    priceId: import.meta.env.VITE_STRIPE_PRO_PRICE_ID,
    features: [
      'Everything in Free',
      'Unlimited linked accounts',
      'Full transaction history',
      'Investment portfolio tracking',
      '20 AI Coach queries/month',
      'Custom budget categories',
      'Bill & subscription detection',
      'CSV export',
      'Priority support',
    ],
    limits: { accounts: Infinity, aiQueries: 20, historyDays: Infinity },
  },
  premium: {
    name: 'Premium',
    price: 14.99,
    priceId: import.meta.env.VITE_STRIPE_PREMIUM_PRICE_ID,
    features: [
      'Everything in Pro',
      'Unlimited AI Coach queries',
      'Net worth tracking & projections',
      'Goal planning with timelines',
      'Tax prep reports',
      'Early access to new features',
      'Dedicated support',
    ],
    limits: { accounts: Infinity, aiQueries: Infinity, historyDays: Infinity },
  },
}

export const stripeService = {
  createCheckoutSession: async (userId, priceId, plan) => {
    const res = await fetch(`${API_BASE}/api/stripe/create-checkout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, priceId, plan }),
    })
    const { url } = await res.json()
    window.location.href = url  // Redirect to Stripe Checkout
  },

  createPortalSession: async (userId) => {
    const res = await fetch(`${API_BASE}/api/stripe/portal`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId }),
    })
    const { url } = await res.json()
    window.location.href = url
  },
}

// ─── Backend: api/stripe/create-checkout.js ───────────────
export const STRIPE_BACKEND = `
import Stripe from 'stripe'
const stripe = new Stripe(process.env.STRIPE_SECRET_KEY)

export default async function handler(req, res) {
  const { userId, priceId } = req.body
  const session = await stripe.checkout.sessions.create({
    mode: 'subscription',
    payment_method_types: ['card'],
    line_items: [{ price: priceId, quantity: 1 }],
    success_url: \`\${process.env.VITE_APP_URL}/dashboard?upgraded=true\`,
    cancel_url: \`\${process.env.VITE_APP_URL}/pricing\`,
    client_reference_id: userId,
    metadata: { userId },
  })
  res.json({ url: session.url })
}

// api/stripe/webhook.js — update plan in DB after payment
export async function webhookHandler(req, res) {
  const sig = req.headers['stripe-signature']
  const event = stripe.webhooks.constructEvent(req.body, sig, process.env.STRIPE_WEBHOOK_SECRET)
  
  if (event.type === 'checkout.session.completed') {
    const { userId } = event.data.object.metadata
    const plan = determinePlanFromPriceId(event.data.object)
    await supabase.from('profiles').update({ plan }).eq('id', userId)
  }
  if (event.type === 'customer.subscription.deleted') {
    const userId = await getUserIdFromCustomer(event.data.object.customer)
    await supabase.from('profiles').update({ plan: 'free' }).eq('id', userId)
  }
  res.json({ received: true })
}
`
